import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DeviceResponseType } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { RemoteButtonState, RemoteButtonStateEnum } from 'lavva.exalushome/build/js/Services/Devices/IDeviceState';
import { ConditionsTypes } from 'lavva.exalushome/build/js/Services/Scenes/Scenes';
import { SupportedArgumentTypes } from 'lavva.exalushome/build/js/Services/Scenes/ScenesBuilder';
import { SubmitButton } from '../../../../../../../../components/submit-button';
import { ConditionTypeSelect } from '../../../../components/condition-type-select';
import { InputString } from '../../../../components/input-string';
import { RemoteTriggerState } from '../../../../components/remote-trigger-state';
import { TriggerMethodSelect } from '../../../../components/trigger-method-select';
import { useExalusCreateActionContext } from '../../../../context';
import { useConditionEdit } from '../../../../hooks/use-condition-edit';
import { TriggerMethodType } from '../../../../../../../../types/actions';

export const RemotesParameters: React.FC = () => {
  const { t } = useTranslation('action');
  const { channels } = useExalusCreateActionContext();
  const [triggerState, setTriggerState] = useState<RemoteButtonStateEnum>(RemoteButtonStateEnum.Relased);
  const {
    triggerMethod,
    seq,
    timeSec,
    conditionType,
    onlyParametersEdit,
    changeableAtMeetCondition,
    setConditionType,
    setTimeSec,
    updateTriggerMethod,
    saveConditionParams,
    createDeviceArgumentWithComparison,
  } = useConditionEdit({ supportedParam: SupportedArgumentTypes.ArgumentAsDeviceState });

  useEffect(() => {
    const argument = seq?.LeftArgument.Argument?.ArgumentAsDeviceState;

    if (argument && onlyParametersEdit) {
      const state = argument.GetCheckDeviceState<RemoteButtonState>();
      setTriggerState(state.State);
    }
  }, [seq, onlyParametersEdit]);

  const handleSubmit = () => {
    if (channels.length) {
      const deviceArgument = createDeviceArgumentWithComparison();
      deviceArgument.Type = DeviceResponseType.RemoteButtonState;
      deviceArgument.DeviceGuid = channels[0].GetDevice().Guid;
      const remoteState = new RemoteButtonState();
      remoteState.Channel = channels[0].Number;
      remoteState.State = triggerState;
      deviceArgument.SetCheckDeviceState<RemoteButtonState>(remoteState);

      saveConditionParams(deviceArgument);
    }
  };

  return (
    <>
      {changeableAtMeetCondition ? (
        <TriggerMethodSelect triggerMethod={triggerMethod} updateTriggerMethod={updateTriggerMethod} />
      ) : null}
      {triggerMethod === TriggerMethodType.WhenChangeOn && changeableAtMeetCondition && (
        <InputString
          value={timeSec}
          setValue={setTimeSec}
          label={t('action.create.conditions.sources.device.requiredTime')}
          inputType="number"
          min={1}
        />
      )}
      <ConditionTypeSelect
        conditionType={conditionType}
        setConditionType={setConditionType}
        allow={[ConditionsTypes.Equal, ConditionsTypes.NotEqueal]}
      />
      <RemoteTriggerState triggerState={triggerState} setTriggerState={setTriggerState} />
      <SubmitButton onClick={handleSubmit} />
    </>
  );
};
